import { defaultTheme } from "@mindlercare/ui-web/src/shared/constants";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import { Typography } from "components/typography";
import { Icon } from "@mindlercare/ui-web";

export const EmptyState = () => {
  const { t } = useTranslation();

  return (
    <>
      <EmptyContainer>
        <Icon.CheckCircle width={20} color={defaultTheme.COLORS.GRAY} />
        <EmptyTextContainer>
          <Typography insensitive variant="body">
            {t("COMPLETED_FEEDBACK")}
          </Typography>
          <Typography insensitive variant="body" color="GRAY">
            {t("NO_FEEDBACK_TODAY")}
          </Typography>
        </EmptyTextContainer>
      </EmptyContainer>
    </>
  );
};

const EmptyContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.PADDING.SM};
  padding-bottom: ${({ theme }) => theme.PADDING.MD};
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_MEDIUM};
`;

const EmptyTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
